// extracted by mini-css-extract-plugin
export default {"login-box":"login-box_login-box__KzFHP","submit-container":"login-box_submit-container__LkSLw","submit":"login-box_submit__aK1s3"};